<template>
    <div class="dataHeaderWrap" :style="{marginTop: marginTop + 'px'}">
        <div class="dataHeader clearfix">
            <div class="dataHeaderSign fl" :style="{background: background}"></div>
            <slot name="title"></slot>
        </div>
        <div class="dataCont">
            <slot name="cont"></slot>             
        </div>
    </div>
</template>

<script>
export default {
    props: ['marginTop', 'background']
}
</script>

<style lang="less">
.newgrey{
    .dataHeaderWrap{
    background: #181c21;
    .dataHeader{
        .dataHeaderSign{
            background: #1B63D9;
        }
    }
    }
} 
.newblack{
    .dataHeaderWrap{
        background: #ffffff;
        .dataHeader{
            .dataHeaderSign{
                background: #1B63D9;
            }
            .dataHeaderTitle{
                color: #272841;
            }
        }
    }
}
.dataHeaderWrap {
    background: #19191B;
    border-radius: 3px;
    .dataHeader {
        height: 31px;
        .dataHeaderSign {
            background: #FF0000;
            width: 3px;
            height: 100%;
            position: relative;
            top: 0px;
        }
        .dataHeaderTitle {
            height: 31px;
            line-height: 31px;
            padding-left: 16px;
            font-size: 14px;
            color: #FFFFFF;
            font-family: Microsoft YaHei;
            .history-hint,.sharing-hint{
                margin-top: 5px;
                margin-left: 10px;
                display: inline-block;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                border: 1px solid #ccc;
                color: #ccc;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
            }
            .history-hint{
                float: left;
            }
        }
        .dataCont {
            font-family: SimSun;
        }
    }
}
</style>